<template>
  <div class="steps-container">
    <step v-for="(item, index) in getPreviousQuestions"
          :step='{label: item.question.node.titleSummary, answers: item.answerSelected}'
          :key="index"
          :questionId="item.question.node._id"
          v-if="getCurrentQuestionId !== item.question.node._id && item.answerSelected"
    />
  </div>
</template>

<script>
  import Step from "./Choice/Granular/Step"
  import gql from 'graphql-tag'
  import { mapActions, mapGetters } from "vuex"

  export default {
    name: "StepsContainer",
    data: function () {
      return {
      }
    },
    components: {
      Step
    },
    computed: {
      ...mapGetters({
        getPreviousQuestions: 'getPreviousQuestions',
        getCurrentQuestionId: 'getCurrentQuestionId'
      })
    }
  }
</script>

<style lang="scss">
  .steps-container {
    margin-top: rem(30px)
  }
</style>